/**
 * @file useIsMobile.ts
 *
 * @fileoverview Help determine if the user is in mobile using matchmedia.
 */

import { useIsScreenSize } from "./useIsScreenSize";

export const useIsMobile = () => useIsScreenSize("mobile");
